import React from 'react'
import { Link } from 'react-router-dom'

const DeveloperTiles = ({language}) => {
    return (
        
        <div id="developer_tiles">
            <div className="tile">
                <Link to={`/control/contentModels`}>
                    <span class="icon"><i class="sprite-icon sprite-icon-black icon-gallery sprite-icon-x400"></i></span>
                    <span>{language.value === 'DA' ? 'Indholds modeller' : 'Content models'}</span>
                </Link>
            </div>
            <div className="tile">
                <Link to={`/control/editors`}>
                    <span class="icon"><i class="sprite-icon sprite-icon-black icon-user sprite-icon-x400"></i></span>
                    <span>{language.value === 'DA' ? 'Brugere' : 'Editors'}</span>
                </Link>
            </div>
            <div className="tile">
                <Link to={`/control/profiles`}>
                    <span class="icon stack">
                        <i class="sprite-icon sprite-icon-black icon-user sprite-icon-x400 x-1"></i>
                        <i class="sprite-icon sprite-icon-black icon-user sprite-icon-x350 x-2"></i>
                    </span>
                    <span>{language.value === 'DA' ? 'Profiler' : 'Profiles'}</span>
                </Link>
            </div>
        </div>
    )
}

export default DeveloperTiles
